import { useEffect } from "react";
import axios from "axios";

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export const useAnalytics = (pageName) => {
  useEffect(() => {
    const trackPageView = async () => {
      try {
        // Track page view - backend will automatically detect country from IP
        await axios.post(`${API}/analytics/track`, {
          page: pageName,
          // No need to send country or IP - backend extracts real IP from headers
        });
      } catch (error) {
        console.error("Analytics tracking error:", error);
      }
    };

    trackPageView();
  }, [pageName]);
};
